<template>
  <div class="col">
    <cc-form-input
      label-cols
      :label="$t('common:single_word.enabled','Enabled') + ':'"
    >
      <b-form-checkbox class="text-right green-checkbox mt-2"
        data-testid="cboStationVariableToggle"
        v-model="enabled"
        switch
        :disabled="disabled"
        >
      </b-form-checkbox>

    </cc-form-input>
  </div>
</template>

<style scoped>
  .green-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    border-color: #28a745;
    background-color: #28a745;
  }
</style>

<script>
export default {
  name : 'station-variable-option',
  props : {
    value : {
      type : Object
    },
    disabled: {
      type: Boolean
    }
  },
  data (){
    return {
      enabled : false,
      selectedFilters : [],

      watchersEnabled : false,
      cooldown : null,
      cooldown_ms : 30,
    }
  },
  methods: {
    refresh(){
      this.enabled = this.value.enabled;
      this.selectedFilters = [...this.value.filters];
    },
    startCooldown(){
      this.cooldown = setTimeout(()=>{
        this.watchersEnabled = true;
      }, this.cooldown_ms);
    },
    emitValue(){
      const stations = this.filterStations();
      this.$emit('input', {
        enabled : this.enabled,
        filters: this.selectedFilters,
        selected : stations
      });
    },
    filterStations(){
      if(this.enabled == false) return [];
      const station_list = [...this.stations];
      for(const filter in this.selectedFilters){
        // Would do the actual filter here, returning the smaller list
      }
      return station_list.map(m => ({ id : m.id, legacy_id: m.legacy_id, name : m.name }));
    }
  },
  computed: {
     stations() {
      return this.$store.state.stations;
    },
  },
  watch: {
    selectedFilters : {
      deep : true,
      handler(){
        if(this.watchersEnabled){
          this.watchersEnabled = false;
          this.emitValue();
          this.startCooldown();
        }
      }
    },
    enabled : {
      deep : true,
      handler(){
        if(this.watchersEnabled){
          this.watchersEnabled = false;
          this.emitValue();
          this.startCooldown();
        }
      }
    },
    value : {
      deep : true,
      handler(){
        this.refresh();
      }
    }
  },
  mounted() {
    this.refresh();
    this.watchersEnabled = true;
  },

}
</script>